const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/import/file-upload/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
const searchSchema = z.object({
  type: z.literal('contacts')
});
export const Route = createFileRoute('/dash/crm/contacts/import/file-upload/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: searchSchema,
  onError(error) {
    throw redirect({
      to: '/dash/crm/contacts/import'
    });
  }
});